import { render, staticRenderFns } from "./DurationOverSpeedReport.vue?vue&type=template&id=19583e18&"
import script from "./DurationOverSpeedReport.vue?vue&type=script&lang=js&"
export * from "./DurationOverSpeedReport.vue?vue&type=script&lang=js&"
import style0 from "./DurationOverSpeedReport.vue?vue&type=style&index=0&id=19583e18&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports